import * as angular from 'angular';

class NetworkPointDetailsOperatorInfoIdentifierComponentCtrl
    implements ng.IController
{
    public isCreateMode: boolean;
    public isEditMode: boolean;
    public eicCheckbox: boolean;
    public identifierExpanded: boolean = true;
    public networkPoint: NetworkPointDto;
    public authorityCode: AuthorityCode[] = ['DVGW', 'EIC', 'ILN', 'EPCP'];

    $onInit() {}
}

angular
    .module('app')
    .component('pkpNetworkPointDetailsOperatorInfoIdentifier', {
        controller: NetworkPointDetailsOperatorInfoIdentifierComponentCtrl,
        template:
            require('app/network-point/network-point-details-operator-info-identifier.component.html'),
        bindings: {
            form: '=',
            networkPoint: '=',
            isEditMode: '<',
            isCreateMode: '<',
            eicCheckbox: '='
        }
    });
